module.exports = __webpack_public_path__ + "static/media/test-phone.1080adcb.jpg";